
import {
  computed, defineComponent, PropType, toRef
} from 'vue';
import useUser from '@/mixins/useUser';
import InnerSection from '@/views/project-forum/components/InnerSection.vue';
import ProjectForumSection from '@/views/project-forum/components/ProjectForumSection.vue';
import { Project } from '@/views/project-forum/models/ProjectForum';
import { buildProjectAdminInfoRows } from '@/views/project-forum/components/admin-info/projectAdminInfo';

export default defineComponent({
  name: 'ProjectAdminInfo',
  components: { InnerSection, ProjectForumSection },
  props: {
    project: {
      type: Object as PropType<Project>,
      required: true,
    },
  },
  setup(props) {
    const project = toRef(props, 'project');
    const { isAdmin, tUserFallback } = useUser('self');
    const rows = computed(() => buildProjectAdminInfoRows(
      project.value.adminStatistics,
      project.value.offersInfo?.acceptsOffers,
    ));
    const rowValue = (value: number | boolean | 'missing') => {
      if (value === 'missing') {
        return String(tUserFallback('project-forum_USERTYPE.admin-info.values.missing'));
      }
      if (typeof value === 'boolean') {
        return String(tUserFallback(`project-forum_USERTYPE.admin-info.values.${value ? 'yes' : 'no'}`));
      }
      return String(value);
    };

    return {
      isAdmin, rowValue, rows, tUserFallback
    };
  },
});
